import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowUpToLine: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M5 3h14' }],
    ['path', { d: 'm18 13-6-6-6 6' }],
    ['path', { d: 'M12 7v14' }],
  ],
];

export default ArrowUpToLine;
